// extracted by mini-css-extract-plugin
module.exports = {"wgjl34j":"wgjl34j","ciwfk5f":"ciwfk5f","s1fd99fx":"s1fd99fx"};